"use client";

import { t } from "@/lib/localization";
import { WalkthroughStep } from "@/lib/utils/lomdaV3/types";

export default function StepLinkSelect({
    steps,
    currentStepId,
    value,
    onChange,
}: {
    steps: WalkthroughStep[];
    currentStepId: string;
    value: string;
    onChange: (linkStepId: string) => void;
}) {
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="h-8 shrink-0 rounded-md border bg-card px-2 lomda-v3-text-small text-muted-foreground outline-none"
        >
            <option value="">{t("lomda-v3-editor.walkthrough.next-step")}</option>
            <option value="none">
                {t("lomda-v3-editor.walkthrough.no-navigate")}
            </option>
            {steps.map((s, i) =>
                s.id === currentStepId ? null : (
                    <option key={s.id} value={s.id}>
                        {s.name ||
                            t("lomda-v3-editor.walkthrough.step-n", undefined, {
                                n: i + 1,
                            })}
                    </option>
                )
            )}
        </select>
    );
}
